import AdvocateLobby from "../advocate/AdvocateLobby";
import PrejoinMeeting from "./Prejoin.Meeting";
import { usePublicMeetingStore } from "../../../store/public.meeting.store";
import { useEffect } from "react";
import { PUBLIC_ADVOCATE_POPUP_KEY } from "../../../utils/advocateLobbyJoin";

const PublicMeeting = () => {
  const meetingState = usePublicMeetingStore((state) => state.meetingState);

  useEffect(() => {
    return () => {
      const isPublicAdvocatePopup =
        window.sessionStorage.getItem(PUBLIC_ADVOCATE_POPUP_KEY) === "1";
      if (!isPublicAdvocatePopup) return;

      window.sessionStorage.removeItem(PUBLIC_ADVOCATE_POPUP_KEY);
      window.close();
      window.setTimeout(() => {
        window.location.replace("/");
      }, 250);
    };
  }, []);

  return (
    <div>
      {meetingState === "prejoin" && <PrejoinMeeting />}
      {meetingState === "lobby" && <AdvocateLobby />}
    </div>
  );
};

export default PublicMeeting;
